function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

export var AudioTrackMeta = /*#__PURE__*/function () {
  function AudioTrackMeta(meta) {
    _classCallCheck(this, AudioTrackMeta);

    var _default = {
      sampleRate: 48000,
      channelCount: 2,
      codec: 'mp4a.40.2',
      config: [41, 401, 136, 0],
      duration: 0,
      id: 2,
      refSampleDuration: 21,
      sampleRateIndex: 3,
      timescale: 1000,
      type: 'audio'
    };

    if (meta) {
      return Object.assign({}, _default, meta);
    }

    return _default;
  }

  _createClass(AudioTrackMeta, [{
    key: "destroy",
    value: function destroy() {
      this.init = null;
    }
  }]);

  return AudioTrackMeta;
}();
export var VideoTrackMeta = /*#__PURE__*/function () {
  function VideoTrackMeta(meta) {
    _classCallCheck(this, VideoTrackMeta);

    var _default = {
      avcc: null,
      sps: new Uint8Array(0),
      pps: new Uint8Array(0),
      chromaFormat: 420,
      codec: 'avc1.640020',
      codecHeight: 720,
      codecWidth: 1280,
      duration: 0,
      frameRate: {
        fixed: true,
        fps: 25,
        fps_num: 25000,
        fps_den: 1000
      },
      id: 1,
      level: '3.2',
      presentHeight: 720,
      presentWidth: 1280,
      profile: 'High',
      refSampleDuration: 40,
      parRatio: {
        height: 1,
        width: 1
      },
      timescale: 1000,
      type: 'video'
    };

    if (meta) {
      return Object.assign({}, _default, meta);
    }

    return _default;
  }

  _createClass(VideoTrackMeta, [{
    key: "destroy",
    value: function destroy() {
      this.init = null;
      this.sps = null;
      this.pps = null;
    }
  }]);

  return VideoTrackMeta;
}();